import { CommonModule, Location } from "@angular/common";
import { Component, OnDestroy } from "@angular/core";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, debounceTime, Subscription } from "rxjs";
import { IonicModule } from "@ionic/angular";
import { SyndicateRepositoryService } from "../syndicate-repository.service";
import * as moment from "moment";
import { ModalController } from "@ionic/angular";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { LeaveSyndicateComponent } from "../leave-syndicate/leave-syndicate.component";
import { PauseSyndicateComponent } from "../pause-syndicate/pause-syndicate.component";
import { MatDialog } from "@angular/material/dialog";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { UnpauseSyndicateBottomsheetComponent } from "../unpause-syndicate-bottomsheet/unpause-syndicate-bottomsheet.component";
import { FormsModule } from "@angular/forms";
import { GameDatasService } from "../../games/services/game-data.service";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { TakeHolidayComponent } from "../take-holiday/take-holiday.component";
import { SeeYouSoonComponent } from "src/app/components/see-you-soon/see-you-soon.component";
import { CommonVariable, LEAVE_SYNDICATE_FAILED } from "src/app/app.constants";
@Component({
  selector: "app-syndicate-pause",
  standalone: true,
  imports: [IonicModule, TranslateModule, CommonModule, FormsModule],
  templateUrl: "./syndicate-pause.component.html",
  styleUrl: "./syndicate-pause.component.scss",
})
export class SyndicatePauseComponent implements OnDestroy {
  public selectedLanguage: string;
  public loader: boolean;
  public latestOngoingSyndicateName: Data;
  public showPausedSyndicate: boolean;
  public syndicate: Data;
  public subscription: Subscription;
  isPausedChecked: boolean;
  syndicatePageOffer$ = new BehaviorSubject(null);
  public lottryDescription$ = new BehaviorSubject("");
  public spinnerAnimation: boolean;
  public progressBar: number;
  public sub: Data;
  public proceed: boolean;
  constructor(
    public translate: TranslateService,
    private location: Location,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
    private authService: AuthService,
    private modalController: ModalController,
    private GTMSegment: GTMSegmentService,
    private dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    public syndicateDataService: SyndicateDataService,
     private gameDatasService : GameDatasService,
  ) {
    this.selectedLanguage = CommonVariable.preferredLanguage;
    this.proceed = true;
    this.loader = true;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );
    this.getOnGoingSyndicate();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.lottryDescription$.unsubscribe();
    this.syndicatePageOffer$.unsubscribe();
  }
  getRedirectionUrl(): string {
    const defaultUrl = "/subscription-settings";
    try {
      const previousUrl = document?.referrer;
      const currentUrl = this.router.url;
      if (!previousUrl || previousUrl?.includes(currentUrl)) {
        return defaultUrl;
      }
      const urlObject = new URL(previousUrl);
      const pathParts = urlObject.pathname;
      return pathParts || defaultUrl;
    } catch (error) {
      return defaultUrl;
    }
  }

  // To navigate back to home page
  dismiss() {
    this.router.navigate([this.getRedirectionUrl()], { replaceUrl: true });
  }
  getResumeDate() {
    return moment()?.add(28, "days").format("DD MMM YYYY");
  }

  async leaveSyndicateConfirmation() {
    this.GTMSegment.HotJarEvent("user_click_leave");
    const leaveSyndicateReason = await this.modalController.create({
      component: LeaveSyndicateComponent,
      cssClass: "modal-fullScreen",
      componentProps: { syndicate: this.syndicate },
    });
    leaveSyndicateReason
      .onDidDismiss()
      .then((res) => {
        if (res?.data) {
          setTimeout(() => {
            this.leaveSyndicateNextStep(res.data, this.syndicate);
          }, 100);
        }
      })
      .catch((error) => {
        return error;
      });
    return await leaveSyndicateReason.present();
  }

  private async leaveSyndicateNextStep(reason, syndicateData) {
    const syndicateHoliday = await this.modalController.create({
      component: TakeHolidayComponent,
      cssClass: "modal-fullScreen",
      componentProps: {
        syndicateData,
        reason,
      },
    });
    syndicateHoliday
      .onDidDismiss()
      .then((res: Data) => {
        if (res?.data?.leaveFinal) {
          syndicateData.fromSubscription = true;
          this.leaveSyndicate(reason, syndicateData);
        } else if (!res?.data?.leaveFinal) {
          setTimeout(() => {
            this.modalController.dismiss().catch((err) => {
              return err;
            });
          }, 300);
        } else {
          syndicateData.active = true;
          return;
        }
      })
      .catch((error) => {
        return error;
      });

    return await syndicateHoliday.present();
  }

  public leaveSyndicate(reason, syndicateData) {
    try {
      this.syndicateService
        .leaveSyndicate(
          syndicateData.id
            ? syndicateData.id
            : syndicateData.encrypted_id
            ? syndicateData.encrypted_id
            : syndicateData.sId,
          syndicateData?.cardType,
          reason
        )
        ?.subscribe((response) => {
          this.progressBar === 100;
          this.sub?.unsubscribe();
          if (response?.status === "rejected") {
            this.authService
              .getConstantsMsg(response?.error_code)
              .then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong!",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: "Error",
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              })
              .catch((error) => {
                return error;
              });
            this.modalController.dismiss().catch((err) => {
              return err;
            });
            if (syndicateData?.fromSubscription) {
              this.router.navigateByUrl("mainTabs/tabs/syndicate");
            }
            return;
          }
          const res = "success";
          if (res === "success") {
            const msg = this.dialog.open(SeeYouSoonComponent, {
              height: "50%",
              data: syndicateData,
            });

            msg?.afterClosed()?.subscribe(
              () => {
                this.modalController.dismiss({ isSuccessLeave: true }).catch((err) => {
                  return err;
                });
                if (syndicateData?.fromSubscription) {
                  this.router.navigateByUrl("mainTabs/tabs/syndicate");
                }
              },
              (err) => {
                return err;
              }
            );
          } else {
            setTimeout(() => {
              const translatedMsg = {
                message: {
                  line_1: LEAVE_SYNDICATE_FAILED,
                  line_2: "",
                },
                style: {
                  duration: 2000,
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              const defaultMsg = {
                message: {
                  line_1: "Leaving syndicate failed",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }, 2000);
            this.modalController.dismiss().catch((err) => {
              return err;
            });
            if (syndicateData?.fromSubscription) {
              this.router.navigateByUrl("mainTabs/tabs/syndicate");
            }
          }

          setTimeout(() => {
            this.spinnerAnimation = false;
            this.proceed = false;
            setTimeout(() => {
              this.proceed = true;
            }, 2000);
          }, 300);
        });
    } catch (e) {
      return e;
    }
  }

  onPauseToggleChange(val: boolean, isPausedChecked) {
    if (val === true && !isPausedChecked) {
      this.GTMSegment.HotJarEvent("user_syndicate_paused");
      this.isPausedChecked = true;
      this.openPauseSyndicate();
    } else if (!this.isPausedChecked) {
      this.GTMSegment.HotJarEvent("user_syndicate_unpaused");
      this.openUnpaused();
    }
  }

  private openPauseSyndicate() {
    const pauseSyndicateDialog = this.bottomSheet.open(PauseSyndicateComponent, {
      panelClass: "pause-syndicate-bottom-sheet",
      data: { syndicate: this.syndicate },
    });

    pauseSyndicateDialog.afterDismissed()?.subscribe(
      (res: boolean) => {
        setTimeout(() => {
          this.authService.fetchLatestOngoingSyndicate();
          if (!res) {
            this.isPausedChecked = false;
            this.modalController.dismiss({ data: "syndicatePaused" }).catch((err) => {
              return err;
            });
          } else {
            this.modalController.dismiss({ data: "syndicatePaused" }).catch((err) => {
              return err;
            });
          }
        }, 2000);
      },
      (err) => {
        return err;
      }
    );
  }

  openUnpaused() {
    const pauseSyndicateDialog = this.dialog.open(UnpauseSyndicateBottomsheetComponent, {
      panelClass: "unpause-syndicate-popup",
      data: { syndicate: this.syndicate },
    });

    pauseSyndicateDialog?.afterClosed()?.subscribe((data) => {
      setTimeout(() => {
        this.authService.fetchLatestOngoingSyndicate();
      }, 3000);
    });
  }

  getOnGoingSyndicate() {
    this.subscription = this.authService?.latestOngoingSyndicate$?.pipe(debounceTime(1000))?.subscribe({
      next: (data) => {
        this.loader = false;
        if (data) {
          this.showPausedSyndicate = true;
          this.latestOngoingSyndicateName = data.syndicate_name;
          this.syndicate = data;
          this.isPausedChecked = this.syndicate?.active_status === "paused" ? true : false;
          if (!this.syndicate?.hasOwnProperty("cardType")) {
            this.syndicate["cardType"] = "Managed";
          }
        } else {
          this.showPausedSyndicate = false;
          this.getOffers();
        }
      },
      error: (error) => {
        this.loader = false;
        return error;
      },
    });
  }

  getOffers() {
    this.syndicateDataService
      ?.getTooltipVipStatus()
      ?.then((res: Data) => {
        const syndicateOfferData = res?.data;
        const description = syndicateOfferData?.content[this.selectedLanguage]?.description;
        this.currencyConversion(description);
        this.syndicatePageOffer$.next(syndicateOfferData);
      })
      .catch((err) => {
        return err;
      });
  }
  async currencyConversion(value: Data | string) {
    if (!value || typeof value !== "string") return;
    const startIndex = value.indexOf("[currency_beautify:");
    const endIndex = value.indexOf("]", startIndex);
    if (startIndex !== -1 && endIndex !== -1) {
      const currencySubstring = value.substring(startIndex, endIndex + 1);
      const currencyValue = await this.gameDatasService.getDVCurrency(currencySubstring);
      if (typeof currencyValue === "string") {
        const description = value.replace(currencySubstring, currencyValue);
        this.lottryDescription$.next(description);
      }
    }
  }

  goToCheckout(name: string, offerId: string) {
    this.router.navigate(["/store/products", name], { queryParams: { payment: offerId } });
  }
}
